<template>
  <div class="app flex-row align-items-center">
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <div :class="{ error: validation.hasError('name') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        id="name"
                        class="form-control"
                        placeholder="Name"
                        v-model="name"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('name')"
                    >
                      <span style="color: red">{{
                        validation.firstError("name")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('phone') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-phone"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="number"
                        id="phone"
                        class="form-control"
                        placeholder="Phone Number"
                        v-model="phone"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('phone')"
                    >
                      <span style="color: red">{{
                        validation.firstError("phone")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('email') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text> @ </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="email"
                        id="email"
                        class="form-control"
                        placeholder="Email"
                        v-model="email"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('email')"
                    >
                      <span style="color: red">{{
                        validation.firstError("email")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('address') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-home"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        id="address"
                        class="form-control"
                        placeholder="Address"
                        v-model="address"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('address')"
                    >
                      <span style="color: red">{{
                        validation.firstError("address")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('address2') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-home"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        id="address2"
                        class="form-control"
                        placeholder="Address 2"
                        v-model="address2"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('address2')"
                    >
                      <span style="color: red">{{
                        validation.firstError("address2")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('pincode') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-eye"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        id="pincode"
                        class="form-control"
                        placeholder="Pincode"
                        v-model="pincode"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('pincode')"
                    >
                      <span style="color: red">{{
                        validation.firstError("pincode")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('password') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        id="password"
                        class="form-control"
                        placeholder="Password"
                        v-model="password"
                        autocomplete="new-password"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('password')"
                    >
                      <span style="color: red">{{
                        validation.firstError("password")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>

                <div :class="{ error: validation.hasError('confPassword') }">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        id="confPassword"
                        class="form-control"
                        placeholder="Repeat password"
                        v-model="confPassword"
                        autocomplete="new-password"
                      />
                    </b-input-group>
                    <template
                      slot="description"
                      v-if="validation.firstError('confPassword')"
                    >
                      <span style="color: red">{{
                        validation.firstError("confPassword")
                      }}</span>
                    </template>
                  </b-form-group>
                </div>
                <div v-if="msg" class="pt-2 pb-4 text-center">
                  <span style="color: red">{{ msg }}</span>
                </div>
                <b-button variant="success" block @click.prevent="validateInput"
                  >Create Account</b-button
                >
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      name: null,
      phone: null,
      email: null,
      address: null,
      address2: null,
      pincode: null,
      password: null,
      confPassword: null,
      msg: null,
    };
  },
  validators: {
    name(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(1)
        .maxLength(120);
    },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(10)
        .maxLength(12);
    },
    email(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .email("Provide a valid email address.");
    },
    address(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^(?=.*[A-Z])(?=.*[a-z])", "Please Input Valid Address.")
        .maxLength(256);
    },
    address2(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^(?=.*[A-Z])(?=.*[a-z])", "Please Input Valid Address.")
        .maxLength(256);
    },
    pincode(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .maxLength(16);
    },
    password(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(128);
    },
    confPassword(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(128);
    },
  },
  methods: {
    validateInput() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.registerUser();
          console.log(response);
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    registerUser() {
      this.appLoading = true;
      var user = {};
      user["Name"] = this.name;
      user["MobileNo"] = this.phone;
      user["Email"] = this.email;
      user["Addr1"] = this.address;
      user["Addr2"] = this.address2;
      user["Pincode"] = this.pincode;
      user["Password"] = this.password;
      axios({
        method: "POST",
        url: "/user/register",
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Login");
          } else {
            this.msg = response.data.msg;
          }
          console.log(response);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
